(function () {
  function hashText(value) {
    var hash = 2166136261;
    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function randomFromSeed(seed) {
    var state = seed >>> 0;
    return function () {
      state += 0x6d2b79f5;
      var value = state;
      value = Math.imul(value ^ (value >>> 15), value | 1);
      value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
  }

  function storeDayKey() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return [values.year, values.month, values.day].join('-');
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function selectDailyCollections(collections, sectionId) {
    var random = randomFromSeed(hashText(storeDayKey() + ':' + sectionId));
    var candidates = collections.slice();
    var selected = [];
    while (selected.length < 3 && candidates.length) {
      var index = Math.floor(random() * candidates.length);
      selected.push(candidates.splice(index, 1)[0]);
    }
    return selected;
  }

  function imageUrl(url, width) {
    if (!url) return '';
    return url.replace(/([?&])width=\d+/, '$1width=' + width);
  }

  function renderCard(card, collection, cardIndex) {
    if (!card || !collection) return;
    var link = card.querySelector('.rootmere-collection-link');
    var image = card.querySelector('img');
    var title = card.querySelector('[data-rootmere-collection-title]');
    var kicker = card.querySelector('.rootmere-collection-kicker');
    link.href = collection.url || ('/collections/' + collection.handle);
    link.setAttribute('aria-label', 'Browse ' + collection.title);
    image.src = imageUrl(collection.image_url, cardIndex === 0 ? 1200 : 800);
    image.srcset = [
      imageUrl(collection.image_url, 480) + ' 480w',
      imageUrl(collection.image_url, 800) + ' 800w',
      imageUrl(collection.image_url, 1200) + ' 1200w',
      imageUrl(collection.image_url, 1600) + ' 1600w'
    ].join(', ');
    image.sizes = cardIndex === 0 ? '(min-width: 901px) 66vw, 100vw' : '(min-width: 901px) 32vw, 50vw';
    image.alt = collection.image_alt || collection.title;
    image.width = Number(collection.image_width) || 1200;
    image.height = Number(collection.image_height) || 1200;
    if (title) title.textContent = collection.title;
    if (kicker) kicker.textContent = cardIndex === 0 ? 'Today’s lead collection' : 'In today’s edit';
  }

  function initialize(root) {
    if (!root || root.dataset.rootmereReady === 'true') return;
    var poolNode = root.querySelector('[data-rootmere-collection-pool]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rootmere-collection-card]'));
    if (!poolNode || cards.length !== 3) return;
    var collections;
    try {
      collections = JSON.parse(poolNode.textContent || '[]');
    } catch (error) {
      return;
    }
    if (!Array.isArray(collections) || collections.length < 3) return;
    var selected = selectDailyCollections(collections, root.dataset.sectionId || 'home');
    selected.forEach(function (collection, index) { renderCard(cards[index], collection, index); });
    root.dataset.rootmereReady = 'true';
    root.dataset.rootmereDay = storeDayKey();
  }

  function initializeAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rootmere-home]'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
